import type {SetAttributes} from '../gutenberg/blocks/pages/Edit';
import type {StyleOptions} from '../gutenberg/blocks/WidgetStyles';
import type {Sections} from '../gutenberg/blocks/widget-styles/Section';


export type ClosableSections = Sections | 'settings';


/**
 * Hook to manage the open state of a section.
 *
 * Style sections and settings support manual opening and closing
 * of sections. We store the closed state in a block attribute, so the
 * next time the block is loaded, the state is preserved and previously
 * closed sections remain closed.
 *
 * @since 9.8.0
 */
export function useOpenSection( attributes: StyleOptions, setAttributes: SetAttributes, section: ClosableSections ): [ boolean, ( open: boolean ) => void ] {
	const isOpen = ! ( attributes.closed_sections?.includes( section ) ?? false );

	return [ isOpen, ( open: boolean ) => {
		if ( open ) {
			setAttributes( {
				closed_sections: attributes.closed_sections.filter( thisSection => thisSection !== section ),
			} );
		} else {
			setAttributes( {
				closed_sections: [ ...attributes.closed_sections, section ],
			} );
		}
	} ];
}
